import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import EnhancedTable from "@meetyoo/components/src/components/Table/EnhancedTable";
import ErrorModal from "@meetyoo/components/src/components/Modal/ErrorModal";

import PMConferenceTableRow, { prepareRowData, headRows } from "../PMConferenceTableRow";

import { setFilter, requestConferences, resetError } from "../../../actions/passcodeManager";

import PMConferencesFilter from "../PMConferencesFilter";

export const PMConferencesComponent = ({
  requestPMConferncesInProgress,
  conferences,
  filter,
  translate,
  sumOfAvailableConferences,
  errorMessage,
  getConferencesHandler,
  setFilterFn,
  resetErrorFn,
}) => {
  const [openErrorModal, setOpenErrorModal] = useState(false);
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(filter.size);
  useEffect(() => {
    setOpenErrorModal(errorMessage !== "");
    if (conferences.length === 0 && errorMessage === "") getConferencesHandler(filter);
    if (page !== filter.page && errorMessage === "") {
      getConferencesHandler(filter);
      setPage(filter.page);
    }
    if (size !== filter.size && errorMessage === "") {
      getConferencesHandler(filter);
      setSize(filter.size);
    }
  }, [getConferencesHandler, conferences.length, page, filter, setPage, size, errorMessage, setOpenErrorModal]);

  const moddedConferences = [];
  for (let i = 0; i < filter.page * filter.size; i += 1) {
    moddedConferences.push({});
  }

  const handleCloseErrorModal = () => {
    setOpenErrorModal(false);
    resetErrorFn();
  };

  return [
    <EnhancedTable
      key="table"
      setReturnPage={returnedPage => setFilterFn({ ...filter, page: returnedPage })}
      setReturnRowsPerPage={returnedRowsPerPage => setFilterFn({ ...filter, size: returnedRowsPerPage })}
      sizeOfRows={sumOfAvailableConferences}
      title={translate.conferences}
      rows={moddedConferences.concat(prepareRowData(conferences))}
      headRows={headRows(translate)}
      tableRowComponent={PMConferenceTableRow}
      inProgress={requestPMConferncesInProgress}
      deleteHandler={rowsToDelete => console.log("rowToDelete: ", rowsToDelete)}
      filterChildren={<PMConferencesFilter />}
      pageState={filter.page}
      rowsPerPageState={filter.size}
    />,
    <ErrorModal
      key="error"
      handleCloseErrorModal={handleCloseErrorModal}
      openErrorModal={openErrorModal}
      errorMessage={errorMessage}
    />,
  ];
};

PMConferencesComponent.defaultProps = {
  conferences: [],
  sumOfAvailableConferences: 999999999999,
};

PMConferencesComponent.propTypes = {
  requestPMConferncesInProgress: PropTypes.bool.isRequired,
  conferences: PropTypes.array,
  getConferencesHandler: PropTypes.func.isRequired,
  filter: PropTypes.object.isRequired,
  setFilterFn: PropTypes.func.isRequired,
  sumOfAvailableConferences: PropTypes.number,
  errorMessage: PropTypes.string.isRequired,
  translate: PropTypes.object.isRequired,
  resetErrorFn: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  requestPMConferncesInProgress: state.passcodeManager.requestPMConferncesInProgress,
  conferences: state.passcodeManager.conferences,
  filter: state.passcodeManager.filter,
  sumOfAvailableConferences: state.passcodeManager.sumOfAvailableConferences,
  errorMessage: state.passcodeManager.errorMessage,
  translate: state.ui.translate,
});

const mapDispatchToProps = dispatch => ({
  getConferencesHandler: filter => dispatch(requestConferences(filter)),
  setFilterFn: filter => dispatch(setFilter(filter)),
  resetErrorFn: () => dispatch(resetError()),
});

const PMConferences = connect(
  mapStateToProps,
  mapDispatchToProps
)(PMConferencesComponent);

export default PMConferences;
